Monthly stock returns are aggregated according to the classification described
in Performance Contribution.
